import { motion } from 'framer-motion';
import { Mic, GraduationCap, Sparkles } from 'lucide-react';

/**
 * Écran d'accueil avec choix du mode :
 *  - Anglais (mode interactif)
 *  - Formations (mode académique, à venir / placeholder)
 */
export default function WelcomeScreen({ onChoose }) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="max-w-5xl mx-auto px-4 py-12" data-testid="academy-welcome">
      <div className="text-center mb-10">
        <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-4 py-1.5 text-xs text-emerald-300 mb-4">
          <Sparkles size={12} />Bienvenue sur ton espace d'apprentissage
        </div>
        <h1 className="text-3xl sm:text-5xl lg:text-6xl font-black tracking-tight">
          <span className="bg-gradient-to-r from-emerald-300 via-yellow-300 to-emerald-200 bg-clip-text text-transparent">Que veux-tu apprendre aujourd'hui ?</span>
        </h1>
        <p className="text-white/60 mt-3 text-sm sm:text-base">Choisis ton parcours pour commencer.</p>
      </div>

      <div className="grid sm:grid-cols-2 gap-5">
        <motion.button whileHover={{ y: -4 }} onClick={() => onChoose('english')} data-testid="welcome-english"
          className="text-left rounded-3xl p-8 bg-gradient-to-br from-emerald-500 to-emerald-700 relative overflow-hidden group">
          <div className="absolute -right-8 -bottom-8 text-9xl opacity-10 group-hover:opacity-20 transition">🇬🇧</div>
          <Mic size={36} className="text-white/80 mb-4" />
          <div className="text-xs uppercase tracking-wider text-white/70">Mode interactif</div>
          <h3 className="text-2xl font-bold mt-1">Anglais</h3>
          <p className="text-white/80 mt-2 text-sm">6 niveaux, du Débutant au Fluent. Apprends en lisant, pratiquant, discutant et répétant.</p>
          <div className="inline-flex items-center gap-1 mt-5 text-sm font-bold bg-white/20 backdrop-blur px-3 py-1.5 rounded-full">Commencer →</div>
        </motion.button>

        <motion.button whileHover={{ y: -4 }} onClick={() => onChoose('formations')} data-testid="welcome-formations"
          className="text-left rounded-3xl p-8 bg-gradient-to-br from-blue-700 to-purple-800 relative overflow-hidden group">
          <div className="absolute -right-8 -bottom-8 text-9xl opacity-10 group-hover:opacity-20 transition">🎓</div>
          <GraduationCap size={36} className="text-white/80 mb-4" />
          <div className="text-xs uppercase tracking-wider text-white/70">Mode académique</div>
          <h3 className="text-2xl font-bold mt-1">Formations</h3>
          <p className="text-white/80 mt-2 text-sm">Formation accélérée : créer sites web & applications avec l'IA — présentiel ou en ligne.</p>
          <div className="inline-flex items-center gap-1 mt-5 text-sm font-bold bg-white/20 backdrop-blur px-3 py-1.5 rounded-full">Découvrir →</div>
        </motion.button>
      </div>
    </motion.div>
  );
}
